import * as React from 'react';
export default function SvgBub() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 12.02c0 1.545-.387 7.191-9.5 7.191-2.599 0-9.5.027-9.5.027V12.02c0-4.322 3.49-7.258 9.5-7.258 5.248 0 9.5 2.146 9.5 7.258zM10.852 9.987c0 1.653-.636 2.993-1.42 2.993-.786 0-1.422-1.34-1.422-2.993 0-1.653.636-2.994 1.421-2.994s1.421 1.34 1.421 2.994zm3.653 2.993c.785 0 1.422-1.34 1.422-2.993 0-1.653-.637-2.994-1.422-2.994-.785 0-1.42 1.34-1.42 2.994 0 1.653.635 2.993 1.42 2.993z"
  }));
}